import { render, staticRenderFns } from "./wisdom.vue?vue&type=template&id=11ceea14&scoped=true"
import script from "./wisdom.vue?vue&type=script&lang=js"
export * from "./wisdom.vue?vue&type=script&lang=js"
import style0 from "./wisdom.vue?vue&type=style&index=0&id=11ceea14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ceea14",
  null
  
)

export default component.exports